import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';
import { BaseApiService } from '@core/api/base-api.service';
import { AuditLogItem } from '../models/audit-log.model';

@Injectable({ providedIn: 'root' })
export class AuditLogsService {
  private readonly api = inject(BaseApiService);

  // Mock cache populated only in non-production builds
  // private readonly mockCache: AuditLogItem[] = environment.production ? [] : buildMockCache();

  getLogs(): Observable<readonly AuditLogItem[]> {
    // if (!environment.production) {
    //   return of(this.mockCache);
    // }
    // TODO: replace path with real endpoint once audit-logs API is confirmed
    return this.api.get<AuditLogItem[]>('/api/v1/audit-logs');
  }
}

// function buildMockCache(): AuditLogItem[] {
//   const STORAGE_KEY = 'mock:auditLogs';
//   const EXPAND_TO = 6;

//   const toUuid = (): string =>
//     typeof crypto !== 'undefined' && 'randomUUID' in crypto
//       ? crypto.randomUUID()
//       : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

//   const templates: Omit<AuditLogItem, 'id'>[] = [
//     {
//       resource: 'api_key',
//       action: 'retry',
//       count: 1,
//       title: 'Retry',
//       message: 'Retrying failed API request with exponential backoff',
//       author: 'dood@mtm.video.com',
//       timestampIso: '2025-10-07T11:01:33Z',
//     },
//     {
//       resource: 'agent',
//       action: 'message_received',
//       count: 3,
//       title: 'Message received',
//       message: 'Ut et mauris quis purus scelerisque gravida.',
//       author: 'dood@mtm.video.com',
//       timestampIso: '2025-10-07T11:01:33Z',
//     },
//     {
//       resource: 'agent',
//       action: 'failure',
//       count: 2,
//       title: 'Failure',
//       message: 'Data analytics agent failed to process large dataset',
//       author: 'dood@mtm.video.com',
//       timestampIso: '2025-10-07T11:01:33Z',
//     },
//     {
//       resource: 'agent',
//       action: 'conversation_started',
//       count: 1,
//       title: 'Conversation started',
//       message: 'New conversation initiated by e-commerce customer',
//       author: 'dood@mtm.video.com',
//       timestampIso: '2025-10-07T11:01:33Z',
//     },
//     {
//       resource: 'api_key',
//       action: 'timeout',
//       count: 1,
//       title: 'Timeout',
//       message: 'GPT-4 API request timed out after 30 seconds',
//       author: 'dood@mtm.video.com',
//       timestampIso: '2025-10-07T11:01:33Z',
//     },
//     {
//       resource: 'agent',
//       action: 'error',
//       count: 2,
//       title: 'Error',
//       message: 'Ut et mauris quis purus scelerisque gravida.',
//       author: 'dood@mtm.video.com',
//       timestampIso: '2025-10-07T11:01:33Z',
//     },
//     {
//       resource: 'message',
//       action: 'message_received',
//       count: 5,
//       title: 'Message received',
//       message: 'Customer replied to conversation thread.',
//       author: 'ops@mtm.video.com',
//       timestampIso: '2025-10-07T11:02:01Z',
//     },
//     {
//       resource: 'system',
//       action: 'retry',
//       count: 2,
//       title: 'Retry',
//       message: 'Transient failure, retry scheduled.',
//       author: 'system@mtm.video.com',
//       timestampIso: '2025-10-07T11:02:10Z',
//     },
//     {
//       resource: 'agent',
//       action: 'conversation_started',
//       count: 1,
//       title: 'Conversation started',
//       message: 'New chat initiated by user from mobile app',
//       author: 'support@mtm.video.com',
//       timestampIso: '2025-10-07T11:02:20Z',
//     },
//     {
//       resource: 'api_key',
//       action: 'timeout',
//       count: 1,
//       title: 'Timeout',
//       message: 'OpenAI request exceeded 30s timeout window',
//       author: 'dba@mtm.video.com',
//       timestampIso: '2025-10-07T11:02:30Z',
//     },
//     {
//       resource: 'agent',
//       action: 'failure',
//       count: 1,
//       title: 'Failure',
//       message: 'Memory overflow detected in summarization task',
//       author: 'runtime@mtm.video.com',
//       timestampIso: '2025-10-07T11:02:40Z',
//     },
//     {
//       resource: 'message',
//       action: 'message_received',
//       count: 2,
//       title: 'Message received',
//       message: 'Webhook delivered new user message',
//       author: 'webhook@mtm.video.com',
//       timestampIso: '2025-10-07T11:03:00Z',
//     },
//     {
//       resource: 'system',
//       action: 'error',
//       count: 1,
//       title: 'Error',
//       message: 'Background sync failed due to auth error',
//       author: 'cron@mtm.video.com',
//       timestampIso: '2025-10-07T11:03:10Z',
//     },
//     {
//       resource: 'api_key',
//       action: 'retry',
//       count: 3,
//       title: 'Retry',
//       message: 'Retry orchestrator picked up failed batch',
//       author: 'system@mtm.video.com',
//       timestampIso: '2025-10-07T11:03:30Z',
//     },
//     {
//       resource: 'agent',
//       action: 'message_received',
//       count: 1,
//       title: 'Message received',
//       message: 'Agent received instruction update',
//       author: 'mtm@mtm.video.com',
//       timestampIso: '2025-10-07T11:03:40Z',
//     },
//     {
//       resource: 'system',
//       action: 'timeout',
//       count: 1,
//       title: 'Timeout',
//       message: 'Queue worker experienced network timeout',
//       author: 'ops@mtm.video.com',
//       timestampIso: '2025-10-07T11:03:50Z',
//     },
//   ];

//   const baseDate = new Date('2025-10-07T11:01:00Z').getTime();
//   const seed: Omit<AuditLogItem, 'id'>[] = Array.from({ length: EXPAND_TO }, (_, idx) => {
//     const t = templates[idx % templates.length];
//     const ts = new Date(baseDate + idx * 15000).toISOString();
//     return { ...t, count: t.count + (idx % 3 === 0 ? 1 : 0), timestampIso: ts };
//   });

//   try {
//     const raw = localStorage.getItem(STORAGE_KEY);
//     if (raw) {
//       const parsed = JSON.parse(raw) as unknown;
//       if (
//         Array.isArray(parsed) &&
//         (parsed as unknown[]).length === EXPAND_TO &&
//         (parsed as unknown[]).every(
//           (it) =>
//             typeof (it as AuditLogItem)?.id === 'string' &&
//             typeof (it as AuditLogItem)?.resource === 'string',
//         )
//       ) {
//         return parsed as AuditLogItem[];
//       }
//     }
//   } catch {}

//   const generated = seed.map((s) => ({ ...s, id: toUuid() }));
//   try {
//     localStorage.setItem(STORAGE_KEY, JSON.stringify(generated));
//   } catch {}
//   return generated;
// }
